"use strict";

var debounce = require("lodash/debounce");
var videoResponser = require("../components/videoImage");

const initCache = () => {
    var $cache = {
        body: $("body"),
        videoComponent: $(".m-product-detail__video"),
        videoContainer: $(".m-product-detail__video-container"),
        videoToggler: $(".m-product-detail__video-toggler"),
        mainCarousel: $(".m-product-detail__main-carousel"),
        desktopSliderPicker: $(".m-product-detail__thumb-images"),
        iframeClass: "m-product-detail__video-iframe",
        iframe: null
    };

    return $cache;
};

const destroyVideoContainer = () => {
    var $cache = initCache();

    if ($cache.videoComponent.length && !$cache.videoComponent.hasClass("d-none")) {
        document.getElementById("pdp_video").pause();
        $cache.videoComponent.addClass("d-none");
        $cache.videoToggler.removeClass("m-product-detail__video-toggler--active");
    }
};

const createIframe = () => {
    var $cache = initCache();

    if (!$cache.videoComponent.hasClass("d-none")) {
        return;
    }

    let video = document.querySelector("#pdp_video");

    if (video) {
        video.setAttribute("controls", "controls");
        video.setAttribute("autoplay", "autoplay");
        video.setAttribute("muted", "muted");
    }

    if (!video.classList.contains("video-responser")) {
        video.classList.add("video-responser");
        videoResponser.videoResponser();
    }

    $cache.videoComponent.removeClass("d-none");
    $cache.videoToggler.addClass("m-product-detail__video-toggler--active");
    handleCarouselState();
};

const handleCarouselState = () => {
    var $cache = initCache();

    if ($cache.videoComponent.length && !$cache.videoComponent.hasClass("d-none")) {
        $cache.desktopSliderPicker.find(".slick-current").removeClass("slick-current");
        $cache.mainCarousel.find(".slick-dots").find(".slick-active").removeClass("slick-active");
    }
};

const initVideoFrame = () => {
    var $cache = initCache();

    $cache.body.on("click", ".m-product-detail__video-toggler", function () {
        createIframe();
    });

    $cache.body.on("click", ".m-product-detail__thumb-image-wrapper", function () {
        destroyVideoContainer();
    });

    $cache.body.on("click", ".m-product-detail__main-carousel .slick-dots li", function () {
        destroyVideoContainer();
    });

    $(window).on("resize", debounce(function () {
        handleCarouselState();
    }, 500));
};

module.exports = {
    initVideoFrame: initVideoFrame
};
